import { getAccountId, getPartnerProxyId } from '@/utils/KeycloakUtils'
import Cookies from 'js-cookie'
import * as CryptoJS from 'crypto-js'

const CP_USER_ID = 'cp_user_id'

export function setCpUserIdCookie(): void {
  const userId = getCpUserId()
  Cookies.set(CP_USER_ID, String(userId), { sameSite: 'lax' })
}

function getCpUserId(): string {
  const partnerProxyId: string | null = getPartnerProxyId()
  if (!partnerProxyId) {
    throw new Error('No partner proxy id available!')
  }

  const accountId: string | null = getAccountId()
  if (!accountId) {
    throw new Error('No account id available!')
  }

  return sha256(partnerProxyId + accountId)
}

function sha256(text: string): string {
  return CryptoJS.SHA256(text).toString(CryptoJS.enc.Hex)
}
